// import Swiper from 'swiper'
// import { Autoplay, Controller, EffectFade, Navigation, Pagination } from 'swiper/modules'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {}

/*
 ######  ##       #### ########  ########
##       ##        ##  ##     ## ##
 ######  ##        ##  ##     ## ######
      ## ##        ##  ##     ## ##
 ######  ######## #### ########  ########
*/
// if (document.getElementsByClassName('js-topConsultant')[0]) {
//   const slideName = '.js-topConsultant'
//   // eslint-disable-next-line no-unused-vars
//   const topConsultantSlide = new Swiper(slideName, {
//     speed: 5000,
//     loop: true,
//     autoplay: {
//       delay: 0,
//       disableOnInteraction: false,
//     },
//     slidesPerView: 'auto',
//     loopAddBlankSlides: true,
//     spaceBetween: 0,
//     breakpoints: {
//       // when window width is >= 769px
//       769: {
//         // speed: 1000,
//       },
//     },
//   })
// }
